import { render, staticRenderFns } from "./FiltersSidebar.vue?vue&type=template&id=bab6e7f8&scoped=true"
import script from "./FiltersSidebar.vue?vue&type=script&lang=js"
export * from "./FiltersSidebar.vue?vue&type=script&lang=js"
import style0 from "./FiltersSidebar.vue?vue&type=style&index=0&id=bab6e7f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab6e7f8",
  null
  
)

export default component.exports